import { CookieConsentBanner } from './CookieConsentBanner'
import { CookieSettingsModal } from './CookieSettingsModal'
import { CookieSettingsButton } from './CookieSettingsButton'

export const CookieConsentManager = () => {
  return (
    <>
      <CookieConsentBanner />
      <CookieSettingsModal />
      <CookieSettingsButton />
    </>
  )
}